const icon = "/_app/immutable/assets/icon.B7pyAb_y.png";
export {
  icon as default
};
